<div class="mat-search-query-builder" *transloco="let translate">
    <query-builder
        [(ngModel)]="query"
        [config]="config"
        [allowRuleset]="allowRuleset"
        [allowCollapse]="allowCollapse"
        [parentChangeCallback]="onParentChange"
        [operatorMap]="customOperatorsMap"
        [emptyMessage]="translate('A ruleset cannot be empty. Please add a rule or remove it all together.')">
        <ng-container
            *queryButtonGroup="let ruleset; let addRule = addRule; let addRuleSet = addRuleSet; let removeRuleSet = removeRuleSet">
            <material-button
                class="leading-[40px]"
                [classList]="['!bg-transparent', '!text-[#3f51b5]', '!mx-[10px]', '!my-[1px]', '!px-[10px]', '!h-[20px]', '!w-[20px]']"
                [buttonType]="'mini-fab'"
                [prefixIcon]="'add'"
                [titleText]="translate('Add Rule')"
                (buttonClicked)="addRule(); openPanel()"></material-button>
            <material-button
                class="leading-[40px]"
                *ngIf="addRuleSet"
                [disabled]="fieldsToBeDisabled.length !== 0"
                [classList]="[
                    '!bg-transparent',
                    '!outline',
                    '!outline-1',
                    '!outline-[#3f51b5]',
                    '!text-[#3f51b5]',
                    '!mx-[10px]',
                    '!px-[10px]',
                    '!my-[1px]',
                    '!h-[20px]',
                    '!w-[20px]'
                ]"
                [buttonType]="'mini-fab'"
                [prefixIcon]="'add'"
                [titleText]="translate('Add Rule Set')"
                (buttonClicked)="addRuleSet(); openPanel()"></material-button>
            <material-button
                class="leading-[40px]"
                *ngIf="removeRuleSet"
                [classList]="[
                    '!bg-transparent',
                    '!outline',
                    '!outline-1',
                    '!outline-[#f44336]',
                    '!text-[#f44336]',
                    '!mx-[10px]',
                    '!my-[1px]',
                    '!px-[10px]',
                    '!h-[20px]',
                    '!w-[20px]'
                ]"
                [buttonType]="'mini-fab'"
                [prefixIcon]="'remove'"
                [titleText]="translate('Remove Rule Set')"
                (buttonClicked)="removeRuleSet()"></material-button>
        </ng-container>
        <ng-container *queryArrowIcon>
            <mat-icon ngClass="mat-arrow-icon">chevron_right</mat-icon>
        </ng-container>
        <ng-container *queryRemoveButton="let rule; let removeRule = removeRule">
            <material-button
                class="leading-[40px]"
                [disabled]="restrictMandatoryFieldsChange(rule.field)"
                [classList]="['!bg-transparent', '!text-[#f44336]', '!mx-[10px]', '!my-[1px]', '!px-[10px]', '!h-[20px]', '!w-[20px]']"
                [buttonType]="'mini-fab'"
                [prefixIcon]="'remove'"
                [titleText]="translate('Remove Rule')"
                (buttonClicked)="removeRule(rule)"></material-button>
        </ng-container>
        <ng-container *querySwitchGroup="let ruleset; let onChange = onChange">
            <material-radio-group
                *ngIf="ruleset"
                [radioOptions]="conditionOptions"
                [selectedValue]="ruleset.condition"
                (selectionChanged)="ruleset.condition = $event; onChange($event)"
                [radioButtonClassList]="['!p-[10px]']"
                [radioGroupClassList]="['!inline-flex']"></material-radio-group>
        </ng-container>
        <ng-container *queryEntity="let rule; let entities = entities; let onChange = onChange">
            <mat-form-field appRemoveAriaOwns>
                <mat-label>Please Select One</mat-label>
                <mat-select [(ngModel)]="rule.entity" (ngModelChange)="onChange($event, rule)">
                    <mat-option *ngFor="let entity of entities; trackBy: trackByEntityMethod" [value]="entity.value">
                        <span [textContent]="entity.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryField="let rule; let fields = fields; let onChange = onChange; let getFields = getFields">
            <mat-form-field appRemoveAriaOwns>
                <mat-label>Please Select One</mat-label>
                <mat-select
                    [(ngModel)]="rule.field"
                    (ngModelChange)="onChange($event, rule)"
                    [disabled]="restrictMandatoryFieldsChange(rule.field)">
                    <mat-option
                        *ngFor="let field of getFields(rule.entity); trackBy: trackByFieldMethod"
                        [value]="field.value"
                        [disabled]="restrictMandatoryFieldsChange(field.value)">
                        <span [textContent]="field.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryOperator="let rule; let operators = operators; let onChange = onChange">
            <mat-form-field class="qbOperator w-[120px]" appRemoveAriaOwns>
                <mat-select
                    [(ngModel)]="rule.operator"
                    (ngModelChange)="onOperatorChange($event, rule)"
                    [disabled]="restrictMandatoryFieldsChange(rule.field)">
                    <mat-option *ngFor="let value of operators; trackBy: trackByOperatorsMethod" [value]="value">
                        <span [textContent]="value"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; let options = options; type: 'category'; let onChange = onChange">
            <mat-form-field *ngIf="rule.operator !== 'IN'" appRemoveAriaOwns>
                <mat-label>Select a value</mat-label>
                <mat-select [(ngModel)]="rule.value" (ngModelChange)="onChange()">
                    <mat-option *ngFor="let opt of options; trackBy: trackByOptionMethod" [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="rule.operator === 'IN'" appRemoveAriaOwns>
                <mat-label>Select value(s)...</mat-label>
                <mat-select [(ngModel)]="rule.value" multiple (ngModelChange)="onChange()">
                    <mat-option *ngFor="let opt of options; trackBy: trackByOptionMethod" [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; let options = options; type: 'boolean'; let onChange = onChange">
            <mat-form-field appRemoveAriaOwns>
                <mat-label>Please Select One</mat-label>
                <mat-select [(ngModel)]="rule.value" (ngModelChange)="onChange()">
                    <mat-option *ngFor="let opt of options; trackBy: trackByOptionMethod" [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; type: 'date'; let onChange = onChange">
            <mat-form-field>
                <mat-label>Enter input</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="rule.value" (ngModelChange)="onChange()" placeholder="dd/mm/yyyy" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let options = options; type: 'multiselect'; let onChange = onChange">
            <mat-form-field class="w-[300px]" appRemoveAriaOwns>
                <mat-select placeholder="Please Select One" [(ngModel)]="rule.value" multiple (ngModelChange)="onChange()">
                    <mat-option *ngFor="let opt of options" [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'number'; let onChange = onChange">
            <mat-form-field *ngIf="rule.operator !== 'IN'" class="w-[200px]">
                <input matInput [(ngModel)]="rule.value" type="number" placeholder="Enter Value" (ngModelChange)="onChange()" />
            </mat-form-field>
            <mat-form-field *ngIf="rule.operator === 'IN'" class="w-[200px]" appearance="outline">
                <mat-label>Enter value(s)...</mat-label>
                <mat-chip-grid #chipList>
                    <mat-chip-row *ngFor="let tagValue of rule.value" (removed)="removeTag(tagValue, rule)">
                        <span [textContent]="tagValue"></span>
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip-row>
                    <input
                        type="number"
                        placeholder="Enter value(s)..."
                        [matChipInputFor]="chipList"
                        focused
                        (matChipInputTokenEnd)="addNewTag($event, rule)"
                        title="Type and hit Enter key or Comma to add multiple values"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur" />
                </mat-chip-grid>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'string'; let onChange = onChange">
            <mat-form-field *ngIf="rule.operator !== 'IN'">
                <input
                    matInput
                    [(ngModel)]="rule.value"
                    (ngModelChange)="onChange()"
                    placeholder="Enter value"
                    [disabled]="restrictMandatoryFieldsChange(rule.field)" />
            </mat-form-field>
            <mat-form-field *ngIf="rule.operator === 'IN'" appearance="outline">
                <mat-label>Enter value(s)...</mat-label>
                <mat-chip-grid #chipList>
                    <mat-chip-row *ngFor="let tagValue of rule.value" (removed)="removeTag(tagValue, rule)">
                        <span [textContent]="tagValue"></span>
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip-row>
                    <input
                        type="text"
                        placeholder="Enter value(s)..."
                        [matChipInputFor]="chipList"
                        focused
                        (matChipInputTokenEnd)="addNewTag($event, rule)"
                        title="Type and hit Enter key or Comma to add multiple values"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur" />
                </mat-chip-grid>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'textarea'; let onChange = onChange">
            <mat-form-field>
                <textarea placeholder="Enter input" matInput [(ngModel)]="rule.value" (ngModelChange)="onChange()"></textarea>
            </mat-form-field>
        </ng-container>
    </query-builder>
    <ng-container *ngIf="isRelationConfig">
        <material-button
            class="d-flex align-items-center justify-content-end"
            (buttonClicked)="relationChanged.emit(query)"
            [text]="'Apply Relation'"></material-button>
    </ng-container>
</div>
